"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Mute = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 11,
  viewBox: "0 0 16 11"
}, props), _react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  d: "M0-3h16v16H0z"
}), _react.default.createElement("path", {
  className: "fill",
  d: "M14.201 5.335l1.595 1.528a.647.647 0 0 1 0 .943.717.717 0 0 1-.984 0l-1.595-1.529-1.595 1.529a.717.717 0 0 1-.983 0 .647.647 0 0 1 0-.943l1.595-1.528-1.595-1.529a.647.647 0 0 1 0-.943.717.717 0 0 1 .983 0l1.595 1.529 1.595-1.529a.717.717 0 0 1 .984 0 .647.647 0 0 1 0 .943l-1.595 1.529zM3.381 2.75L6.818.15C7.295-.208 8 .113 8 .69v9.622c0 .577-.705.897-1.182.537L3.381 8.25H.727C.326 8.25 0 7.942 0 7.562V3.438c0-.38.326-.687.727-.687h2.654z"
})));

var _default = Mute;
exports.default = _default;